/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Zotero_Browser_All_ItemsInputs */

const en_zotero_browser_all_items = /** @type {(inputs: Zotero_Browser_All_ItemsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All Items`)
};

const es_zotero_browser_all_items = /** @type {(inputs: Zotero_Browser_All_ItemsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todos los elementos`)
};

/**
* | output |
* | --- |
* | "All Items" |
*
* @param {Zotero_Browser_All_ItemsInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const zotero_browser_all_items = /** @type {((inputs?: Zotero_Browser_All_ItemsInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Zotero_Browser_All_ItemsInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_zotero_browser_all_items(inputs)
	return en_zotero_browser_all_items(inputs)
});